import PropTypes from 'prop-types'

import Badge, {atomBadgeDesigns, atomBadgeSizes} from '@s-ui/react-atom-badge'
import {atomIconSizes} from '@s-ui/react-atom-icon'
import AtomTooltip, {AtomTooltipPlacements} from '@s-ui/react-atom-tooltip'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import InfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline'

const DisclaimerBasic = ({iconBadge, label, tooltipContent, type}) => {
  const isMobile = !useMediaQuery(useMediaQueryBreakpoints.md)

  const delayTooltip = isMobile ? {show: 0, hide: 0} : {show: 0, hide: 2000}

  return (
    <div className="mt-DisclaimerBasic">
      <div>
        <Badge design={atomBadgeDesigns.SOFT} icon={iconBadge} label={label} type={type} size={atomBadgeSizes.LARGE} />
      </div>
      <AtomTooltip
        delay={delayTooltip}
        placement={AtomTooltipPlacements.BOTTOM}
        color="neutral"
        content={tooltipContent}
      >
        <div className="mt-DisclaimerBasicInfoIcon">
          <InfoOutline size={atomIconSizes.medium} />
        </div>
      </AtomTooltip>
    </div>
  )
}

DisclaimerBasic.displayName = 'DisclaimerBasic'
DisclaimerBasic.propTypes = {
  iconBadge: PropTypes.node,
  label: PropTypes.string,
  tooltipContent: PropTypes.node,
  type: PropTypes.string
}

export default DisclaimerBasic
